module.exports = __webpack_public_path__ + "static/img/ap1.7c992e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap1.jpg
// module id = ifSl
// module chunks = 1